module.exports = __webpack_public_path__ + "0ecf0020.svg";


//////////////////
// WEBPACK FOOTER
// ./src/desktop/components/Favourite/heart-red.svg
// module id = 1740
// module chunks = 15 18 19 20 32 36 37